import { capitalizeFirstLetter } from "../string_convert_helper";

// The audit types the report form offers (its audit_types lookup), in its
// order.
export const AUDIT_TYPES = [
	{ key: "rig_intake", label: "Rig intake" },
	{ key: "internal_audits", label: "Internal audits" },
	{ key: "external_audits", label: "External audits" },
	{ key: "authority_audits", label: "Authority audits" },
	{ key: "rig_inspections", label: "Rig inspections" },
	{ key: "management_review", label: "Management Review" },
] as const;

const MANAGEMENT_REVIEW = "management_review";

// The types the form offers: Management Review only on internal audits.
export const getAuditTypeOptions = (isInternal: boolean) =>
	isInternal
		? AUDIT_TYPES
		: AUDIT_TYPES.filter((type) => type.key !== MANAGEMENT_REVIEW);

// How a stored audit type reads. A type the form doesn't offer reads as its
// words; a dash when there's no text.
export function getAuditTypeLabel(type: unknown): string {
	if (typeof type !== "string" || type.trim() === "") return "—";
	const known = AUDIT_TYPES.find((option) => option.key === type);
	return known?.label ?? capitalizeFirstLetter(type.replace(/_/g, " ").trim());
}
